var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-card-grid"},_vm._l((_vm.cards),function(card){return _c('Card',{directives:[{name:"view",rawName:"v-view.once",modifiers:{"once":true}}],key:card.title,attrs:{"asset":card.asset,"content":card.body}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }